<template>
    <div>
        <div :class="[headerFont, 'grey--text font-weight-regular']">{{header}}</div>
        <div style="line-height: 1.2 ;" :class="css"><slot></slot></div>
    </div>
</template>

<script>
    export default {
        name: "info-line",
        props: {
            header: {default: ''},
            css: {default: 'mb-3 subtitle-1'},
            headerFont: {default: 'subtitle-2'},
        },
    }
</script>

<style scoped>
    .mb-05{margin-bottom: 2px}
</style>